import { render } from "./Screenfull.vue?vue&type=template&id=5af81770"
import script from "./Screenfull.vue?vue&type=script&lang=js"
export * from "./Screenfull.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__